import Vue from 'vue'
import enums from '@/enums'
import { formatPrice, isSellOut } from "@/helpers";

Vue.filter('price', function (price) {
  return formatPrice(price)
})

Vue.filter('isSellOut', function (specInfo) {
  return isSellOut(specInfo)
})

Vue.filter('imgUrl', function (url) {
  if (typeof url === 'object') {
    url = url.url
  }
  return url ? url : require('@/assets/no-image.jpg')
})

Vue.filter('enums', function (value, enumName) {
  return enums[enumName].label(value)
})

